import { Button } from "components/Button/Button";
import { CheckableButton } from "components/CheckableButton/CheckableButton";
import { useState } from "react";
import { trans } from "utils/helpers";
import { postTransfer } from "../api";
import { Toast } from "components/ToastShow/ToastAlert";
import { MessageType } from "types/enum";

interface Prop {
  onHide: () => void;
  reload: () => void;
  showForm: () => void;
  mode: string;
}

export const TransmissionForm = ({ onHide, reload, showForm, mode }: Prop) => {
  const [transferType, setTransferType] = useState<"quantity" | "value">(
    "value"
  );
  const [source, setSource] = useState("LastYearInventory");

  const handleSubmit = async (event) => {
    event.preventDefault();
if(   event.target.isRegisteredByPrice.value!="value"
        &&  event.target.isRegisteredByPrice.value!="quantity"){ 
              Toast(
      trans(`یک مورد را انتخاب کنید`),
      MessageType.error,

    );
          return null
        }

    Toast(
      trans(`اطلاعات موجودی ابتدای دوره حذف و موجودی کالاها از گردش سال قبل جایگزین می شود.<br/>ادامه می دهید؟`),
      MessageType.confirm,
      async () => {
        // normally you would call an API here
        const res = await postTransfer(
          JSON.parse(localStorage.getItem("DefaultInventory") as any)?.Id,
          JSON.parse(localStorage.getItem("DefaultDetailInventory") as any)
            ?.Id ?? undefined,
          event.target.isRegisteredByPrice.value=="value"?true:false,
          event.target.isRegisteredByPrice.value=="quantity"?true:false
        );
        reload(); // close + refresh parent
        showForm(); // also trigger parent handler
      }
    );
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="card">
        <div className="card-body">
          {/* Source dropdown */}
          {/* <div className="mb-3 col-3">
            <SelectBox
              lable={trans("RestoreFrom")} // برگرداندن ابتدایی دوره از
              name="source"
              options={["LastYearInventory",
              ]}
              value={source}
              val={[trans("InventoryFromLastYear")]}
              onChange={(val) => setSource(val)} selectType={"select"}            />
          </div> */}

          {/* Transfer type radio buttons */}
          <div className="row mb-3">
            <div className="col-auto">
              <CheckableButton
                labelText={trans("TransferQuantity")} // انتقال موجودی مقداری
                inputName="isRegisteredByPrice"
                type="radio"
                value={"quantity"}
                required
              />
            </div>
            <div className="col-auto">
              <CheckableButton
                labelText={trans("TransferValueAndType")} // انتقال موجودی جنسی و ریالی
                inputName="isRegisteredByPrice"
                type="radio"
                value={"value"}
                required
              />
            </div>
          </div>
        </div>
      </div>

      {/* Action buttons */}
      <div className="col-lg-12 mt-3 btns_form">
        {mode !== "view" ? (
          <>
            <Button value={trans("Confirm")} btnType="submit" /> {/* تایید */}
            <Button
              btnType="cancel"
              value={trans("Cancel")}
              onClick={onHide}
            />{" "}
            {/* انصراف */}
          </>
        ) : (
          <Button btnType="primary" value={trans("Close")} onClick={onHide} />
        )}
      </div>
    </form>
  );
};
